if (!customElements.get('announcement-countdown')) {
  class AnnouncementCountdown extends HTMLElement {
    constructor() {
      super();
      this.intervalId = null;
    }

    connectedCallback() {
      this.dateStr = this.getAttribute('data-date');
      this.timeStr = this.getAttribute('data-time') || '00:00';
      this.completedAction = this.getAttribute('data-completed') || 'hide_slide';
      this.daysEl = this.querySelector('[data-unit="days"]');
      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      this.timerEl = this.querySelector('.announcement-countdown__timer');
      this.completedEl = this.querySelector('.announcement-countdown__completed');

      if (this.dateStr) {
        this.tick();
        this.intervalId = setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }

    tick() {
      const target = new Date(`${this.dateStr}T${this.timeStr}:00`);
      const now = new Date();
      const distance = target.getTime() - now.getTime();

      if (distance <= 0) {
        this.onCompleted();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.updateUnit(this.daysEl, days);
      this.updateUnit(this.hoursEl, hours);
      this.updateUnit(this.minutesEl, minutes);
      this.updateUnit(this.secondsEl, seconds);
    }

    updateUnit(el, value) {
      if (!el) return;
      el.textContent = String(value).padStart(2, '0');
    }

    onCompleted() {
      clearInterval(this.intervalId);
      this.intervalId = null;

      if (this.completedAction === 'hide_slide') {
        const slide = this.closest('.swiper-slide');
        if (slide) {
          slide.style.display = 'none';
          const swiperEl = this.closest('.announcement-bar__swiper');
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
          }
        }
        const slider = this.closest('announcement-slider');
        if (slider) {
          const visibleSlides = slider.querySelectorAll('.swiper-slide:not([style*="display: none"])');
          if (visibleSlides.length === 0) {
            slider.style.display = 'none';
            document.documentElement.style.setProperty('--announcement-height', '0px');
            document.documentElement.style.setProperty('--ann-height', '0px');
          }
        }
      } else if (this.completedAction === 'show_text') {
        if (this.timerEl) this.timerEl.style.display = 'none';
        if (this.completedEl) this.completedEl.style.display = 'flex';
      }
    }
  }

  customElements.define('announcement-countdown', AnnouncementCountdown);
}
